import { Grid, Typography } from "@mui/material";
import React from "react";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

function MyJourney() {
  return (
    <Grid
      className="animated-box"
      sx={{ mx: "auto", width: "75%", color: "white" }}
    >
      <Grid>
        <Typography
          h1
          className="neon-text"
          neontext=""
          sx={{ textAlign: "center", fontSize: "2rem", mb: "1rem" }}
        >
          My Journey
        </Typography>
      </Grid>
      <Grid container className="box-text" spacing={5}>
        <Grid item className="my-journey-text">
          <FollowTheSignsIcon color="secondary" fontSize="large" />I embarked on
          my tech odyssey at university, mastering programming fundamentals
          before diving into web development with Node.js, Django, Angular and
          React.
          <GolfCourseIcon color="secondary" fontSize="medium" />
          and from there, I dove into the world of desktop applications with
          Electron.js.
          <GolfCourseIcon color="secondary" fontSize="medium" /> I was
          fascinated by the potential of AI, and soon enough, I was integrating
          it into my projects using Python, ML libraies and AI APIs.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> My expertise
          expanded to WordPress for blogging and Odoo for ERP solutions.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> I even enjoyed
          orchestrating large-scale projects and improving teamwork using
          various software management tools like GitLab, JIRA, BitBucket,
          Sentry, Docker and AWS infrastructure.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> As my journey
          continued, I picked up mobile app development skills with React
          Native. <GolfCourseIcon color="secondary" fontSize="medium" /> I
          explored immersive Web AR/VR, creating new dimensions of interaction.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> The AI
          revolution led me to master prompt engineering for LLMs.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> I also designed
          AI agents using frameworks like CrewAI for complex automation.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> The Open-Source
          World became my playground for global collaboration.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> However I
          always strive to improve my skills and mentality to build reliable and
          useful software.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" /> <br />
          Notion and the 12-week-year methodology maximize my productivity.{" "}
          <GolfCourseIcon color="secondary" fontSize="medium" />
          <br /> I believe in continuous learning and improvement, and I'm
          excited to see where my journey takes me next.
          <AutoGraphIcon color="secondary" fontSize="large" />
          <AutoStoriesIcon color="secondary" fontSize="large" />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MyJourney;
